import React from 'react';
import { BsViewStacked } from 'react-icons/bs';
import { FaArrowLeft } from 'react-icons/fa';
import Bandeira from '../../assets/bandeira.png';
import Mercosul from '../../assets/mercosul-logo.svg';
import { useSteps } from '../../contexts/stepContext';
import { Title } from '../../styles/global';
import { Content, GoBack } from '../BodyStep/styles';
import Button from '../Button';
import { Details, Line, Placa } from './styles';

const PlacaDetails: React.FC = () => {
  const { handleReturnCurrentStep, handleInitialCurrentStep, car } = useSteps();
  return (
    <Content>
      <GoBack onClick={handleReturnCurrentStep}>
        <FaArrowLeft size={16} />
        voltar
      </GoBack>
      <Title>Detalhes do Veículo</Title>

      <Placa>
        <header>
          <img alt="Logo Mercosul" src={Mercosul} />
          <h1>Brasil</h1>
          <img alt="Bandeira do Brasil" src={Bandeira} />
        </header>
        <footer>
          <h2>{car.car_plate}</h2>
          <p>BR</p>
        </footer>
      </Placa>
      <Details>
        <Line>
          <label>Local: </label>
          <h3>
            {car.loc_name} - {car.loc_city} - {car.loc_state}
          </h3>
        </Line>
        <Line>
          <label>Modelo: </label>
          <h3>{car.car_model}</h3>
        </Line>
        <Line>
          <label>Chassi: </label>
          <h3>{car.car_chassi}</h3>
        </Line>
      </Details>

      <Button
        title="Voltar para Operacoes"
        onClick={handleInitialCurrentStep}
        icon={BsViewStacked}
      />
    </Content>
  );
};

export default PlacaDetails;
